export default "__VITE_PUBLIC_ASSET__d75cd508__"